<app-icon-button
  id="resolve-btn"
  class="rounded-md"
  [class.resolve-single-thread]="isResolveSingleThreadButton"
  [svgIconPath]="'Resolve2'"
  [type]="'basic'"
  [disabled]="isDisabled"
  [ngbTooltip]="!isDisabled && tooltipTranslationText | translate"
  [placement]="placement"
>
</app-icon-button>
